import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/system'
import { Box, Typography } from '@mui/material'
import Button from 'components/common/Buttons/Button'
import IconButton from 'components/common/Buttons/IconButton'
import { ReactComponent as CloseIcon } from 'assets/svgs/actions/close.svg'
import { useTextualContext } from 'contexts/TextualContext'

const StyledBox = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.common.white,
	borderRadius: '12px',
	padding: '24px 24px 64px 24px',
	boxShadow: '0px 0px 20px 0px #0000001F',
	gap: 2,
	textAlign: 'center',
	'.idle-timer-content-text-container': {
		paddingInline: 16,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		'.idle-timer-content-secondary-button': {
			order: 1,
		},
	},
	[theme.breakpoints.up('lg')]: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '720px',
		'.idle-timer-content-text-container': {
			paddingInline: 72,
			'.idle-timer-content-secondary-button': {
				order: 'unset',
			},
		},
	},
}))

const IdleTimerContent = ({ handleStay, handleLogout, remaining }) => {
	const { t } = useTextualContext()

	const idleTimerTitleText = t('idle-timer.title')
	const idletimerDescriptionText = t('idle-timer.description')
	const idleTimerLogoutText = t('idle-timer.button-secondary')
	const idleTimerLogoutStayText = t('idle-timer.button-primary')
	const idleTimerRemainingText = t('idle-timer.remaining-seconds-text')

	const minuteAndSecond = `${Math.floor(remaining / 60)} mins 
    ${remaining % 60} secs`

	return (
		<StyledBox>
			<Box display="flex" justifyContent="flex-end">
				<IconButton onClick={handleStay} aria-label={'close'} color="primary">
					<CloseIcon />
				</IconButton>
			</Box>
			<Box className="idle-timer-content-text-container">
				<Box py={3}>
					<Typography
						variant="titleMedium"
						color="primary.main"
						component={'h1'}
					>
						{idleTimerTitleText}
					</Typography>
				</Box>
				<Box pb={3}>
					<Typography
						variant="bodyMedium"
						color="primary.main"
						id={'session-timeout-title'}
					>
						{idletimerDescriptionText}
					</Typography>
				</Box>
				<Box pb={6}>
					<Typography
						variant="bodyMedium"
						color="primary.main"
						id={'session-timeout-description'}
					>
						{idleTimerRemainingText}
					</Typography>
					<Typography variant="titleSmall" color="secondary.main" noWrap>
						{minuteAndSecond}
					</Typography>
				</Box>
				<Box display="flex" flexWrap={'wrap'} justifyContent={'center'} gap={2}>
					<Button
						className="idle-timer-content-secondary-button"
						variant={'secondary'}
						onClick={handleLogout}
					>
						{idleTimerLogoutText}
					</Button>
					<Button onClick={handleStay}>{idleTimerLogoutStayText}</Button>
				</Box>
			</Box>
		</StyledBox>
	)
}

IdleTimerContent.propTypes = {
	handleStay: PropTypes.func,
	handleLogout: PropTypes.func,
	remaining: PropTypes.number,
}

IdleTimerContent.defaultProps = {
	handleStay: () => {},
	handleLogout: () => {},
	remaining: 0,
}

export default IdleTimerContent
